import { useTranslation } from "react-i18next";
import { Tag } from "lucide-react";

/** Compacte merkkiezer (segmented pills): alle merken of één merk. */
export const BrandTabs = ({ merken, actief, onKies, label = false, testId = "catalog-brand-tabs" }) => {
  const { t } = useTranslation();
  if (!merken || merken.length < 2) return null;

  const pil = (aan) =>
    `rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
      aan ? "bg-foreground text-background shadow-sm" : "text-muted-foreground hover:text-foreground"
    }`;

  return (
    <div data-testid={testId}>
      {label && (
        <p className="mb-3 flex items-center gap-2 text-sm font-semibold">
          <Tag className="h-4 w-4 text-primary" aria-hidden="true" />
          {t("catalog.brands")}
        </p>
      )}
      <div className="inline-flex flex-wrap items-center gap-0.5 rounded-full border bg-card p-0.5">
        <button type="button" onClick={() => onKies("")} className={pil(!actief)} aria-pressed={!actief} data-testid={`${testId}-all`}>
          {t("catalog.allBrands")}
        </button>
        {merken.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => onKies(m.id)}
            className={pil(actief === m.id)}
            aria-pressed={actief === m.id}
            data-testid={`${testId}-${m.id}`}
          >
            {m.naam}
            <span className={`ml-1.5 text-[10px] ${actief === m.id ? "text-background/70" : "text-muted-foreground"}`}>{m.aantal}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
